<template>
  <v-container grid-list-xs>
    <h2>Redirigiendose a APS Virtual ...</h2>
  </v-container>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import AppConfig from "@/config/AppConfig";

export default {
      computed: {
    ...mapGetters([      
      "userProfile",
      "userScopes"
    ])
  },
  methods: {
    loginRedirect() {
      this.$store
        .dispatch("refreshToken", this.$route.params.token)
        .then(res => {
          if (res.data.code == "401") {
            this.$router.push("/session/login");
            location.reload();
          } else {
            this.$store
              .dispatch("loginWeb", {
                access: this.$route.params.token,
                refresh: this.$route.params.rtoken,
                expiredTime: this.$route.params.etime,
                expiredRefreshTime: this.$route.params.eRtime
              })
              .then(res => {
                if (res.data.code == 200) {
                  setTimeout(() => {
                  if(this.userScopes.includes("aps_admin")){
                      this.$router.push("/pushNotifications");
                    } else if(this.userScopes.includes("aps_promotor")){
                      this.$router.push("/orderEmision/orderEmisionList");
                    } else{
                      this.$router.push("/");
                    }
                  }, 500);
                } else if (res.data.code == 404 || res.data.code == 401) {
                  this.$root.$emit(
                    "showSnackBar",
                    "Usuario y/o contraseña incorrecto",
                    "error"
                  );
                }
              })
              .finally(() => {
                this.loading = false;
              });
          }
        });
    }
  },
  mounted() {
    this.loginRedirect();
  }
};
</script>

<style>
</style>
